import { OverlayService } from './../../../services/overlay.service';
import { PublicationService } from './../../../services/publication.service';
import { Publication } from './../../../interfaces/publication';
import { ClipboardService } from 'ngx-clipboard';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
	selector: 'bb-qrcode',
	templateUrl: './bb-qrcode.component.html',
	styleUrls: ['./bb-qrcode.component.scss']
})

export class BbQRCodeComponent implements OnInit, OnDestroy {
	@Input() entity: any;
	@Input() redirectUrl: string;
	@Input() qrCodeImgUrl: string;
	@Input() hideImageUrl: boolean;

	subscriptions: Subscription;

	type: string;

	constructor(
		private translate: TranslateService,
		private publicationService: PublicationService,
		private clipboard: ClipboardService,
		private overlayService: OverlayService
	) {
		this.subscriptions = new Subscription();
	}

	ngOnInit() {
		this.subscriptions.add(
			this.publicationService.getData().subscribe((publication: Publication) => {
				const baseUrl = publication.baseurl;
				this.type = this.entity && this.entity.type && this.entity.type.toLowerCase();
				if (typeof this.redirectUrl === 'undefined' && typeof this.qrCodeImgUrl === 'undefined') {
					this.redirectUrl = `https:${baseUrl}/sapi/redirect/${this.type}/${this.entity.id}`;
					this.qrCodeImgUrl = `https:${baseUrl}/sapi/qrcode/${this.type}/${this.entity.id}`;
				}
			})
		);
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	copyText(text: string): void {
		this.clipboard.copyFromContent(text);
		this.overlayService.createToast(this.translate.instant('QRCODE_IMAGE_URL_COPIED_TO_CLIPBOARD'), 'copy');
	}
}
